import isModalOpen from './isModalOpen'

export { isModalOpen }

export default {
  computed: {
    ...isModalOpen.computed
  }
}
